import { CareCreditCollectMultiSteps } from '../../collect-multi-step.types';
import { useCareCreditCollectContext } from '../../context/care-credit-collect.context';

type CollectStepPerformanceWrapperProps = React.PropsWithChildren<{
  step: CareCreditCollectMultiSteps;
}>;

export const CollectStepPerformanceWrapper = ({ children, step }: CollectStepPerformanceWrapperProps) => {
  const {
    multiStep: { activeStep },
  } = useCareCreditCollectContext();

  if (step !== activeStep) return null;

  return <>{children}</>;
};
